
export default {
  name: 'PrimaryTitle',
}
